import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getCateringFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How do I book a food ${vehicleType} for an event in ${cityName}?`,
    answer: `Start a catering request with your date, location, guest count, and a few event details. We'll find available ${vehicleType}s; they send quotes, and you compare them before you book.`
  },
  ...(cityName === 'Seattle' ? [
      {
        question: 'How can I book a food truck in Bellevue for a corporate event?',
        answer: "SeattleFoodTruck.com regularly books food trucks for corporate events in Bellevue and across the Eastside. Whether you're planning an office lunch, employee appreciation event, or client gathering, you can request quotes from experienced food trucks that are familiar with corporate campuses, timing requirements, and large group service. Our team is also available to help with coordination and logistics."
      },
      {
        question: 'Is food truck catering available in Redmond for weddings or private parties?',
        answer: 'Yes. Food truck catering is a popular option for weddings and private events in Redmond. SeattleFoodTruck.com works with food trucks that cater everything from wedding receptions and rehearsal dinners to birthday parties and backyard celebrations. You can choose from a wide range of cuisines and service styles to match your event and guest preferences.'
      },
      {
        question: 'Can I hire a food truck for my wedding or private event in Tacoma?',
        answer: 'Absolutely. SeattleFoodTruck.com connects clients with food trucks that cater weddings, private parties, and community events throughout Tacoma and the surrounding areas. Our vendors are experienced in off-site catering and can accommodate a variety of venues, guest counts, and service formats, making food trucks a flexible and memorable option for your event.'
      }
    ] : []),
  {
    question: `How much does food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: 'Are there fees?',
    answer: `Requesting quotes is free. Before you book, you'll see the full price, including platform fees.`
  },
  {
    question: 'How far ahead should I book?',
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  },
  {
    question: `Can I book more than one ${vehicleType}?`,
    answer: `Yes. Multiple ${vehicleType}s are common for larger events, mixed cuisines, or shorter service windows.`
  }
];

function CateringFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getCateringFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default CateringFaq;
